import { render } from "./abtesting_group_a_app.vue?vue&type=template&id=1724677d"
import script from "./abtesting_group_a_app.vue?vue&type=script&lang=js"
export * from "./abtesting_group_a_app.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__